/* Social (Tab Mods) */

import { css } from 'styled-components';
import theme from 'theme/theme';
import { media } from 'theme/utils';
import { styleBase, styleHero, styleReverse } from '../styles';

const { colors } = theme;

const Hero = {
  key: 'Hero',
  styledComponent: css`
    ${styleHero}

    &&& {
      background-size: auto 10rem;
      background-position: bottom -4.6rem center;

      ${media.md`
        background-size: contain;
        background-position: bottom -0.5rem left 26rem;
      `}

      ${media.lg`
        background-size: cover;
        background-position: bottom -2rem left 47rem;
      `}
    }
  `,
};

const Goal = {
  key: 'Goal',
  styledComponent: styleBase,
};

const Serve = {
  key: 'Serve',
  styledComponent: css`
    ${styleBase}
    ${styleReverse}

    &&& {
      background: ${colors.whiteGrey};
    }
  `,
};

const Support = {
  key: 'Support',
  styledComponent: css`
    ${styleBase}

    &&& {
      div[class*='descriptionWrapper'] {
        ul {
          display: flex;
          flex-direction: row;
          flex-wrap: wrap;
          justify-content: space-evenly;
          margin: 0;
          padding: 0;
          list-style: none;

          li {
            width: 8em;
            margin: 1.2em 0;

            > div div:first-child {
              flex-direction: column;
              align-items: center;
              font-size: 1.125em;
              font-weight: 700;
              line-height: 1.2;
              text-align: center;

              img {
                width: 5.7em;
                margin: 1em 0;
              }
            }
          }
        }
      }

      ${media.md`
        div[class*='content'] {
          align-items: flex-start;
        }

        div[class*='images'] {
          padding-top: 3em;
        }
      `}

      ${media.lg`
        div[class*='content'] {
          align-items: center;
        }

        div[class*='descriptionWrapper'] ul {
          flex-wrap: nowrap;
        }
      `}
    }
  `,
};

const Wellness = {
  key: 'Wellness',
  styledComponent: css`
    ${styleBase}

    &&& {
      background: ${colors.whiteGrey};

      div[class*='images'] {
        display: flex;
        flex-flow: row wrap;
        justify-content: space-evenly;

        > div {
          flex: 0 1 50%;
          padding: 1.4%;
        }
      }

      ${media.md`
        div[class*='content'] {
          flex-direction: column;
        }

        div[class*='images'] {
          max-width: 61em;
          padding: 0;

          > div {
            flex: 0 1 28%;
          }
        }

        div[class*='descriptionWrapper'] {
          width: 70%;
          padding: 1em 0 4em;
          text-align: center;
        }
      `}

      ${media.lg`
        div[class*='content'] {
          justify-content: space-evenly;
        }

        div[class*='descriptionWrapper'] {
          max-width: unset;
        }
      `}
    }
  `,
};

export const Social = {
  key: '/responsibility-social',
  content: [Hero, Goal, Serve, Support, Wellness],
};

export default Social;
